// pouchdb-react-native -> PouchDB on IndexedDB
import PouchDB from "pouchdb-browser";

function WebPouchDB(name, options) {
  const opts = Object.assign({}, options);
  delete opts.adapter;
  return new PouchDB(name, opts);
}

WebPouchDB.plugin = function(plugin) {
  if (plugin && plugin.__webNoop) {
    return WebPouchDB;
  }
  PouchDB.plugin(plugin && plugin.default ? plugin.default : plugin);
  return WebPouchDB;
};

export default WebPouchDB;
